import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type ChangeModelLinkClasses = 'container' | 'label' | 'icon';

const changeModelLinkStyles = makeStyles<ISpcTheme, ChangeModelLinkClasses>(
  theme => ({
    container: {
      alignItems: 'center',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      lineHeight: '14px',
      color: theme.palette.common.white,
      display: 'flex',
    },
    label: {
      fontSize: theme.typography.fontSM,
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.fontMD,
      },
    },
    icon: {
      color: theme.palette.common.white,
      fontSize: theme.typography.fontMD,
    },
  }),
  { name: 'Common_ChangeModelLink' },
);

export default changeModelLinkStyles;
